import { PromotionRepository } from '../../domain/repositories/promotion.repository';

export class DeletePromotionUseCase {
  constructor(private readonly promotionRepository: PromotionRepository) {}

  async execute(id: string): Promise<void> {
    return this.promotionRepository.deletePromotion(id);
  }
}
